import React from "react";
import moment from "moment";
import FilterByDates from "components/misc/FilterByDates";

const AccountingFilters = ({
  openPeriods,
  selectedOpenPeriod,
  setSelectedOpenPeriod,
  periodStatusFilter,
  setPeriodStatusFilter,
  selectedDateStart,
  setSelectedDateStart,
  selectedDateEnd,
  setSelectedDateEnd
}) => (
  <div>
    <div className="flex items-center gap-3 mb-2">
      <span className="text-lg font-semibold text-blue-700 tracking-wide">Opciones de Búsqueda</span>
      <span className="ml-2 px-2 py-0.5 rounded bg-blue-100 text-blue-600 text-xs font-medium">Filtros</span>
    </div>
    <div className="flex flex-col gap-2">
      <div className="flex flex-wrap justify-center items-center gap-3">
        <label htmlFor="period-select" className="font-semibold">Por periodos activos:</label>
        <select
          id="period-select"
          name="period-select"
          value={selectedOpenPeriod}
          onChange={e => setSelectedOpenPeriod(e.target.value)}
          className="px-4 py-2 border border-blue-200 rounded shadow-sm min-w-[220px] focus:ring-2 focus:ring-blue-300 focus:border-blue-400 transition"
          style={{ minWidth: 220 }}
        >
          {openPeriods.length === 0 ? (
            <option value="">No hay periodos abiertos</option>
          ) : (
            openPeriods.map(p => (
              <option key={p.id} value={p.id}>
                {p.startDate} - {p.endDate}
              </option>
            ))
          )}
        </select>
        <label htmlFor="period-status-select" className="font-semibold">Por estatus:</label>
        <select
          id="period-status-select"
          name="period-status-select"
          value={periodStatusFilter}
          onChange={e => setPeriodStatusFilter(e.target.value)}
          className="px-4 py-2 border border-blue-200 rounded shadow-sm min-w-[120px] focus:ring-2 focus:ring-blue-300 focus:border-blue-400 transition"
          style={{ minWidth: 120 }}
        >
          <option value="all">Todos</option>
          <option value="open">Abierto</option>
          <option value="closed">Cerrado</option>
          <option value="archived">Archivado</option>
        </select>
      </div>
      <div className="flex flex-wrap justify-center items-center gap-3 -mt-2">
        <label htmlFor="date-select" className="font-semibold">Rango de Fechas:</label>
        <FilterByDates
          id="date-select"
          selectedDateStart={selectedDateStart}
          setSelectedDateStart={date => setSelectedDateStart(date && moment.isMoment(date) ? date : date ? moment(date) : null)}
          selectedDateEnd={selectedDateEnd}
          setSelectedDateEnd={date => setSelectedDateEnd(date && moment.isMoment(date) ? date : date ? moment(date) : null)}
        />
      </div>
    </div>
  </div>
);

export default AccountingFilters;
